const HIDE_DELAY_MS = 3000;
const ACTIVITY_EVENTS = ['pointermove', 'pointerdown', 'keydown', 'touchstart'] as const;

export interface CaptureModeHandle {
  enterFullscreen(): Promise<void>;
  destroy(): void;
}

export function attachCaptureMode(rootEl: HTMLElement, controlsEl: HTMLElement): CaptureModeHandle {
  let timeoutId: number | null = null;

  const showControls = (): void => {
    controlsEl.classList.remove('is-hidden');
    rootEl.classList.remove('is-capture');
    if (timeoutId !== null) window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      controlsEl.classList.add('is-hidden');
      rootEl.classList.add('is-capture');
    }, HIDE_DELAY_MS);
  };

  const onActivity = (): void => showControls();
  for (const event of ACTIVITY_EVENTS) {
    window.addEventListener(event, onActivity, { passive: true });
  }
  showControls();

  return {
    async enterFullscreen() {
      try {
        await document.documentElement.requestFullscreen();
      } catch {
        /* Safari tabs etc. — silent no-op as designed */
      }
    },
    destroy() {
      for (const event of ACTIVITY_EVENTS) {
        window.removeEventListener(event, onActivity);
      }
      if (timeoutId !== null) window.clearTimeout(timeoutId);
    },
  };
}
